/* Dukaanwali redesign carousels.
   data-dw-carousel + data-autoplay="sec": step autoplay (hero, reviews).
   data-dw-carousel + data-dw-flow="px/s": continuous seamless loop (product + category rows).
   Both: native swipe/scroll, arrows, pause on hover/touch/focus, stop when off-screen, hidden tab or reduced motion.
   Motion starts after the first user interaction or 5s after load, so it never competes with page load. */
(function(){
  var RM=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
  var ready=[],armed=0;
  function arm(){if(armed)return;armed=1;ready.forEach(function(f){f()});ready=[]}
  function whenIdle(f){armed?f():ready.push(f)}
  ['scroll','pointerdown','touchstart','keydown','mousemove'].forEach(function(e){window.addEventListener(e,arm,{once:true,passive:true})});
  function late(){setTimeout(arm,5000)}
  document.readyState==='complete'?late():window.addEventListener('load',late,{once:true});

  function gap(t){return parseFloat(getComputedStyle(t).columnGap)||12}
  function step(t){var c=t.firstElementChild;return c?c.getBoundingClientRect().width+gap(t):200}

  function init(el){
    if(el.__dw)return;el.__dw=1;
    var t=el.querySelector('[data-dw-track]');if(!t)return;
    var p=el.querySelector('[data-dw-prev]'),n=el.querySelector('[data-dw-next]');
    var flow=parseFloat(el.getAttribute('data-dw-flow')||'0'),auto=parseFloat(el.getAttribute('data-autoplay')||'0');
    var paused=0,vis=0,rt,setW=0,cloned=0,pos=0,last=0;
    function hold(){paused=1;clearTimeout(rt)}
    function rel(ms){clearTimeout(rt);rt=setTimeout(function(){pos=t.scrollLeft;paused=0},ms||0)}
    function wrap(){if(cloned&&setW&&t.scrollLeft>=setW){t.scrollLeft-=setW;pos=t.scrollLeft}}
    function go(d){
      if(flow&&cloned){hold();if(d<0&&t.scrollLeft<step(t))t.scrollLeft+=setW;t.scrollBy({left:d*step(t),behavior:'smooth'});rel(2500);return}
      var end=t.scrollLeft+t.clientWidth>=t.scrollWidth-4;
      if(d>0&&end){t.scrollTo({left:0,behavior:'smooth'})}else{t.scrollBy({left:d*step(t),behavior:'smooth'})}
    }
    p&&p.addEventListener('click',function(){go(-1)});n&&n.addEventListener('click',function(){go(1)});
    el.addEventListener('mouseenter',hold);el.addEventListener('mouseleave',function(){rel(400)});
    el.addEventListener('touchstart',hold,{passive:true});el.addEventListener('touchend',function(){rel(3000)},{passive:true});
    el.addEventListener('focusin',hold);el.addEventListener('focusout',function(){rel(1500)});
    if('IntersectionObserver' in window){new IntersectionObserver(function(e){vis=e[0].isIntersecting},{rootMargin:'100px'}).observe(el)}else{vis=1}
    var more=el.getAttribute('data-dw-more'),extra=parseInt(el.getAttribute('data-dw-extra')||'0',10),fed=!more,waiting=[];
    function fed1(f){fed?f():waiting.push(f)}
    function done(){fed=1;waiting.forEach(function(f){f()});waiting=[]}
    function feed(){
      if(fed||feed.busy)return;feed.busy=1;
      fetch(more,{credentials:'same-origin'}).then(function(r){return r.ok?r.text():''}).then(function(h){
        var d=document.createElement('div');d.innerHTML=h;var src=d.querySelector('[data-dw-feed]'),end=t.querySelector('[data-dw-all]');
        if(src){[].slice.call(src.children,0,extra||999).forEach(function(k){end?t.insertBefore(k,end):t.appendChild(k)})}
        done();
      }).catch(done);
    }
    if(more){
      var arm2=function(){if('IntersectionObserver' in window){var io=new IntersectionObserver(function(e){if(e[0].isIntersecting){io.disconnect();feed()}},{rootMargin:'0px 0px 500px 0px'});io.observe(el)}else{feed()}};
      document.readyState==='complete'?arm2():window.addEventListener('load',arm2,{once:true});
      t.addEventListener('scroll',feed,{passive:true,once:true});
    }
    if(RM||(!flow&&!auto))return;

    if(!flow){whenIdle(function(){setInterval(function(){if(!paused&&vis&&!document.hidden)go(1)},auto*1000)});return}

    var items;
    function measure(){var a=items[0],b=items[items.length-1];setW=b.offsetLeft+b.offsetWidth+gap(t)-a.offsetLeft}
    function clone(){
      items=[].slice.call(t.children);
      if(cloned||t.scrollWidth<=t.clientWidth+8)return 0;
      var f=document.createDocumentFragment();
      items.forEach(function(it){var c=it.cloneNode(true);c.setAttribute('aria-hidden','true');c.removeAttribute('data-dw-all');
        c.querySelectorAll('a,button').forEach(function(a){a.tabIndex=-1});
        c.querySelectorAll('img').forEach(function(i){i.loading='lazy';i.removeAttribute('fetchpriority')});f.appendChild(c)});
      t.appendChild(f);cloned=1;t.classList.add('is-flow');measure();return 1;
    }
    t.addEventListener('scroll',function(){if(paused)wrap()},{passive:true});
    window.addEventListener('resize',function(){cloned&&measure()});
    function tick(ts){
      requestAnimationFrame(tick);
      var dt=last?Math.min(ts-last,50):16;last=ts;
      if(paused||!vis||document.hidden)return;
      pos+=flow*dt/1000;if(pos>=setW)pos-=setW;t.scrollLeft=pos;
    }
    function startFlow(){fed1(function(){if(clone()){pos=t.scrollLeft;requestAnimationFrame(tick)}})}
    whenIdle(function(){if(more&&!fed&&vis)feed();startFlow()});
  }
  function all(r){(r||document).querySelectorAll('[data-dw-carousel]').forEach(init)}
  document.readyState==='loading'?document.addEventListener('DOMContentLoaded',function(){all()}):all();
  document.addEventListener('shopify:section:load',function(e){all(e.target)});
})();

/* Sticky add-to-cart bar: add a "Buy now" button next to "Add to cart" (theme renders the bar from a <template>). */
(function(){
  if(!/\/products\//.test(location.pathname))return;
  function add(){
    var box=document.querySelector('.t4s-sticky-atc__btns');
    if(!box||box.querySelector('.dw-sticky-buy'))return;
    var b=document.createElement('button');b.type='button';b.className='dw-sticky-buy';b.textContent='Buy now';
    b.addEventListener('click',function(){
      var atc=box.querySelector('[data-variant-id]'),q=box.querySelector('input[name="quantity"]');
      var id=atc&&atc.getAttribute('data-variant-id');if(!id)return;
      b.disabled=true;b.textContent='...';
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:+id,quantity:Math.max(1,parseInt(q&&q.value||'1',10))}]})})
        .then(function(){location.href='/checkout'}).catch(function(){b.disabled=false;b.textContent='Buy now'});
    });
    box.appendChild(b);
  }
  new MutationObserver(add).observe(document.documentElement,{childList:true,subtree:true});
  add();
})();
/* offer box: follow selected variant */
(function(){var box=document.querySelector('[data-dw-offer]');if(!box)return;var map;try{map=JSON.parse(box.querySelector('[data-dw-offer-v]').textContent)}catch(e){return}
var free=+box.getAttribute('data-free-at'),a=box.querySelector('[data-dw-offer-a]'),b=box.querySelector('[data-dw-offer-b]');
function rs(c){return 'Rs.'+Math.round(c/100).toLocaleString('en-US')}
function upd(id){var v=map[id];if(!v)return;var p=v[0],c=v[1];if(c>p){a.hidden=false;a.innerHTML='<span class="dw-offer__pct">'+Math.round((c-p)*100/c)+'% OFF</span><span class="dw-offer__sv">Sale price. You save <strong>'+rs(c-p)+'</strong></span>'}else{a.hidden=true}
b.textContent=p>=free?'\uD83D\uDE9A Free delivery':'\uD83D\uDE9A '+rs(free-p)+' away from free delivery'}
var form=box.closest('form');var inp=form&&form.querySelector('[name="id"]');if(!inp)return;var last=inp.value;
setInterval(function(){if(inp.value!==last){last=inp.value;upd(last)}},400);})();
